export default __webpack_public_path__ + "static/media/federico.aa9209bd.png";